<template>
  <v-card class="employee-card">
    <h2>Update Pickup Date</h2>
    <div class="employee-list-block">
      <div class="alert-container">
        <span><i class="fas fa-info-circle"></i> Please select the date in <strong>DD-MM-YYYY</strong> format and time in <strong>HH:mm</strong> (24-hour) format.</span>
      </div>
      <div class="disclaimer-container" v-if="isStationManaged">
        <span><i class="fas fa-exclamation-triangle"></i> <strong>Disclaimer:</strong> Scheduled pickup time is an estimate based on real-time route data. Edits are permitted and will be logged for trip audit purposes.</span>
      </div>
      <div v-if="tripDetails.serviceType === 1">
        <div class="employee-list" v-for="(employee, index) in tripDetails.employees" :key="index">
          <!-- {{ checkDisabledTime(tripDetails.reportingTime, employee.selectedTime) }} -->
          <span>{{ employee.name }}</span>

          <div class="date-picker-container">
            <date-picker v-model="employee.selectedDate" value-type="format" format="DD-MM-YYYY" placeholder="DD-MM-YYYY" type="date" @input="(val) => updateField(employee, 'selectedDate', val)" :disabled-date="checkDisabledDate" :clearable="false" />
            <date-picker v-model="employee.selectedTime" format="HH:mm" placeholder="HH:MM" value-type="format" type="time" @input="(val) => updateField(employee, 'selectedTime', val)" :default-value="employee.selectedTime" :disabled-time="checkDisabledTime" :clearable="false" />
          </div>
          <!-- :default-value="employee.selectedDate" -->
        </div>
      </div>
      <div v-else>
        <div class="employee-list">
          <span>Pickup Time</span>
          <div class="date-picker-container">
            <date-picker v-model="selectedDate" value-type="format" format="DD-MM-YYYY" placeholder="DD-MM-YYYY" type="date" :clearable="false" />
            <date-picker v-model="selectedTime" format="HH:mm" placeholder="HH:MM" value-type="format" type="time" :clearable="false" />
          </div>
        </div>
      </div>
    </div>
    <div class="card-button-blk">
      <v-btn color="#f4c736" @click="cancelSubmit" small>Cancel</v-btn>
      <v-btn color="#eea004" @click="submit" small>Submit</v-btn>
    </div>
  </v-card>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment-timezone";
import axios from "@/axios/axios-global";

export default {
  name: "PickUpTimeUpdate",
  components: { DatePicker },
  data() {
    return {
      selectedDate: null,
      selectedTime: null,
      employees: [],
    };
  },
  props: {
    tripDetails: Object,
    driverDetails: Object,
    vehicleData: Object,
    timeStampDetails: Object,
  },
  //  watch: {
  //   tripDetails() {
  //    this.tripDetails.employees.map((employee) => {
  //     employee["selectedDate"] = moment(employee.pickupdate, "DD-MM-YYYY hh:mm A").format("DD-MM-YYYY");
  //     console.log(employee.selectedDate);
  //    });
  //   },
  //  },
  created() {
    // Pre-fill the estimated time for every station (isStationManaged is now always true).
    this.tripDetails.employees.forEach((employee) => {
      // Use employee.newPickupdate if it exists (suggested pickup date from DB)
      // Otherwise fall back to employee.pickupdate, reportingTime, or current time
      const sourceTime = employee.newPickupdate || employee.pickupdate || this.tripDetails.reportingTime || this.getNow();

      // Parse the source time. If it's the custom string format, parse with format, otherwise as timestamp
      const parsed = typeof sourceTime === 'string' && sourceTime.includes('-')
        ? moment.tz(sourceTime, "DD-MM-YYYY hh:mm A", this.getTimeZone())
        : moment.tz(sourceTime, this.getTimeZone());

      this.$set(employee, "selectedDate", parsed.format("DD-MM-YYYY"));
      this.$set(employee, "selectedTime", this.isStationManaged ? parsed.format("HH:mm") : "");
    });

    const tripAt = this.tripDetails.serviceType === 2 ? this.tripDetails.reportingTime : (this.tripDetails.pickUpTime || this.tripDetails.reportingTime || this.getNow());
    this.selectedDate = moment.tz(tripAt, this.getTimeZone()).format("DD-MM-YYYY");
    this.selectedTime = this.isStationManaged ? moment.tz(tripAt, this.getTimeZone()).format("HH:mm") : "";
  },
  computed: {
    // Every station now gets the managed pickup behaviour. This was previously gated on
    // STATION_MANAGED_BRANCHES (BLR/COK/HYD/MAA) matched against tripDetails.branch - restore
    // that check here, and re-import the constant, to go back to a per-station rollout.
    isStationManaged() {
      return true;
    },
    formattedDates() {
      return this.tripDetails.employees.map((employee) => {
        const sourceTime = employee.newPickupdate || employee.pickupdate || this.tripDetails.reportingTime || this.getNow();
        const parsed = typeof sourceTime === 'string' && sourceTime.includes('-')
          ? moment.tz(sourceTime, "DD-MM-YYYY hh:mm A", this.getTimeZone())
          : moment.tz(sourceTime, this.getTimeZone());
        return parsed.format("YYYY-MM-DD");
      });
    },
    formattedTimes() {
      return this.tripDetails.employees.map((employee) => {
        const sourceTime = employee.newPickupdate || employee.pickupdate || this.tripDetails.reportingTime || this.getNow();
        const parsed = typeof sourceTime === 'string' && sourceTime.includes('-')
          ? moment.tz(sourceTime, "DD-MM-YYYY hh:mm A", this.getTimeZone())
          : moment.tz(sourceTime, this.getTimeZone());
        return parsed.format("HH:mm");
      });
    },
  },
  methods: {
    //   updatePickUpDate(newDate, index) {
    //    this.selectedDate = moment(newDate, "YYYY-MM-DD").format("DD-MM-YYYY");
    //   },
    //   updatePickUpTime(newTime, index) {
    //    console.log(newTime);
    //    const currentDate = moment(this.tripDetails.employees[index].pickupdate, "DD-MM-YYYY hh:mm A").format("DD-MM-YYYY");
    //    this.selectedTime = moment(`${currentDate} ${newTime}`, "DD-MM-YYYY HH:mm").format("hh:mm A");
    //   },

    //   confirm(data, index) {
    //    this.$set(data, "dateMenu", false);
    //    if (!this.selectedDate) this.selectedDate = moment(data.pickupdate, "DD-MM-YYYY hh:mm A").format("DD-MM-YYYY");
    //    const dateTime = moment(`${this.selectedDate} ${this.selectedTime ? this.selectedTime : moment(data.pickupdate, "DD-MM-YYYY hh:mm A").format("hh:mm A")}`, "DD-MM-YYYY hh:mm A").format(
    //     "DD-MM-YYYY hh:mm A"
    //    );
    //    this.$set(data, "changedDate", dateTime);

    //    //  let employees = []

    //    //  this.$set(this.tripDetails, "employees", employees);
    //   },

    updateField(employee, field, value) {
      this.$set(employee, field, value);
      if (field === "selectedDate") this.selectedDate = value;
      if (field === "selectedTime") this.selectedTime = value;
    },

    getTimeZone() {
      return (this.timeStampDetails && this.timeStampDetails.timeZone) || "Asia/Kolkata";
    },

    getNow() {
      if (this.timeStampDetails && this.timeStampDetails.time) {
        return moment.tz(this.timeStampDetails.time, this.getTimeZone());
      }
      return moment.tz(this.getTimeZone());
    },

    submit() {
      const tz = this.getTimeZone();
      let changedDate = "";
      let employeeIds = [];
      if (this.tripDetails.employees.every((employee) => employee.selectedTime) || this.selectedTime) {
        if (this.tripDetails.serviceType === 1) {
          employeeIds = this.tripDetails.employees.map((e) => e.crewId);
          this.employees = this.tripDetails.employees.map((employee) => {
            const dateTimeStr = `${employee.selectedDate} ${employee.selectedTime}`;
            const parsed = moment.tz(dateTimeStr, "DD-MM-YYYY HH:mm", tz);
            employee["changedDate"] = parsed.format("DD-MM-YYYY hh:mm A");

            // isChanged must reflect whether the submitted time differs from the trip's CURRENT pickupdate.
            // The backend (updateEtsPickupdate) only persists employees where isChanged === true, so comparing
            // against newPickupdate would mark "approved the suggestion" as unchanged and keep the old pickupdate.
            const originalSource = employee.pickupdate || this.tripDetails.reportingTime || this.getNow();
            const originalParsed = typeof originalSource === 'string' && originalSource.includes('-')
              ? moment.tz(originalSource, "DD-MM-YYYY hh:mm A", tz)
              : moment.tz(originalSource, tz);

            const date1 = originalParsed.format("DD-MM-YYYY hh:mm A");
            const date2 = employee.changedDate;

            return {
              id: employee.id,
              pickupTime: parsed.valueOf(),
              isChanged: date1 !== date2,
            };
          });
        } else {
          employeeIds = this.tripDetails.employees.map((e) => e.crewId);
          this.employees = [];
          changedDate = moment.tz(`${this.selectedDate} ${this.selectedTime}`, "DD-MM-YYYY HH:mm", tz).valueOf();
        }
        this.$emit("submit", { employees: this.employees, pickUpdate: changedDate, crewIds: employeeIds.length > 0 ? employeeIds : [] });
      } else {
        this.$toasted.show("Please select time", {
          position: "bottom-center",
          duration: 5000,
        });
      }

      // this.$emit("submit", employees);
    },
    cancelSubmit() {
      this.tripDetails.employees.forEach((employee) => {
        if (employee.hasOwnProperty("changedDate")) {
          this.$delete(employee, "changedDate");
        }
      });
      this.$emit("cancelSubmit");
    },
    cancelCalendar(data, index) {
      this.$set(data, "dateMenu", false);
    },
    convertDate(date) {
      return moment(date, "DD-MM-YYYY hh:mm A").format("YYYY-MM-DD");
    },
    convertTime(date) {
      const date1 = moment(date, "DD-MM-YYYY hh:mm A");
      const date2 = moment(this.selectedDate, "DD-MM-YYYY");
      if (this.selectedDate && !date1.isSame(date2, "date")) {
        return "";
      } else {
        return moment(date, "DD-MM-YYYY hh:mm A").format("HH:mm");
      }
    },

    formatTime(time) {
      if (!time) return "";
      // Handle ISO timestamp format (2026-04-16T09:40:00)
      return moment(time).format("HH:mm");
    },

    //     checkDisabledTime(pickupdate) {
    //   //    const employeeDetails = this.tripDetails.employees.find((employee) => employee.selectedTime === moment(pickupdate).format("HH:mm"));
    //   const reportingTime = moment(this.tripDetails.reportingTime).subtract(10, "minutes").format("HH:mm");
    //   const pickupdateTime = moment(pickupdate).format("HH:mm");
    //   //    if (employeeDetails && employeeDetails.selectedDate !== moment(this.tripDetails.reportingTime).subtract(20, "minutes").format("DD-MM-YYYY")) {
    //   //     return true;
    //   //    } else {
    //   return pickupdateTime > reportingTime;
    //   //    }
    // },

    checkDisabledTime(pickedTime) {
      const tz = this.getTimeZone();
      const reportingM = moment.tz(this.tripDetails.reportingTime, tz).subtract(20, "minutes");
      const reportingDate = reportingM.format("DD-MM-YYYY");
      const reportingTime = reportingM.format("HH:mm");
      const pickupdateTime = moment.tz(pickedTime, tz).format("HH:mm");

      if (this.selectedDate === reportingDate) {
        return pickupdateTime > reportingTime;
      } else {
        return false;
      }
    },

    checkDisabledDate(pickupdate) {
      const tz = this.getTimeZone();
      const reportingLimit = moment.tz(this.tripDetails.reportingTime, tz).subtract(20, "minutes");
      const pickLimit = moment.tz(pickupdate, tz);
      return pickLimit.isAfter(reportingLimit, 'day') || (pickLimit.isSame(reportingLimit, 'day') && pickLimit.isAfter(reportingLimit));
    },
    //   clubTrip(data) {
    //     this.$emit("club-trip",data);
    //   }
  },
};
</script>
+

<style lang="scss" scoped>
.employee-card {
  padding: 10px;
  border-radius: 0;
  h2 {
    text-align: center;
    border-bottom: 1px solid #d5d5d5;
    font-weight: bold;
  }
  .employee-list-block {
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .alert-container {
      font-size: 12px;
      background: #c8f2ff;
      padding: 5px;
    }
    .disclaimer-container {
      font-size: 12px;
      background: #fff3cd;
      padding: 8px;
      border-left: 3px solid #ffc107;
      i {
        color: #ff9800;
        margin-right: 5px;
      }
    }
    .employee-list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #fddddd;
      padding: 10px;

      .date-picker-container {
        display: flex;
        gap: 10px;
      }
      //    .fas {
      //     color: #e70101;
      //     font-size: 13px;
      //     margin-left: 10px;
      //     cursor: pointer;
      //    }
    }
  }
  .card-button-blk {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    padding: 10px;
    border-top: 1px solid #ebebeb;
  }
}

.v-date-time-widget-container .flex {
  display: flex;
  flex-direction: column;
  padding: 0 5px;
  justify-content: space-between;
}

.v-date-time-widget-container .flex.text-xs-center {
  flex-direction: row;
  justify-content: flex-end;
  padding: 0;
}

.v-date-time-widget-container {
  background: white;
  padding: 15px;
}

.v-date-time-widget-container {
  background: white;
  padding: 15px;
}

.row {
  margin-top: 0;
}
.v-date-time-widget-container h3 {
  font-weight: 800;
  font-size: 1.1rem;
  //  color: #db670f;
  text-align: center;
  padding: 5px 0;
}
.calendar-footer {
  padding: 5px !important;
}
.v-date-time-widget-container .calendar-footer .v-btn {
  margin-left: 10px;
}
</style>
